"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var Language = function Language(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    stroke: "currentColor",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("g", {
    "clip-path": "url(#clip0_3477_8750)"
  }, (0, _preact.h)("path", {
    d: "M14.5 13.5L11 6.5L7.5 13.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), (0, _preact.h)("path", {
    d: "M8.5 11.5H13.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), (0, _preact.h)("path", {
    d: "M5.5 2V3.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), (0, _preact.h)("path", {
    d: "M1.5 3.5H9.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), (0, _preact.h)("path", {
    d: "M7.5 3.5C7.5 5.0913 6.86786 6.61742 5.74264 7.74264C4.61742 8.86786 3.0913 9.5 1.5 9.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    fill: "transparent"
  }), (0, _preact.h)("path", {
    d: "M3.84375 5.5C4.2573 6.66971 5.02329 7.68246 6.03626 8.3988C7.04922 9.11515 8.25934 9.49988 9.5 9.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    fill: "transparent"
  })));
};

var _default = Language;
exports.default = _default;